export default __webpack_public_path__ + "static/media/aboutus-profitriskloss.8866095e.jpg";